module.exports = __webpack_public_path__ + "img/51_25.8aeecd16.png";